<template>
  <transition name="overlay-fade">
    <div
      v-if="showOverlay"
      class="tap-to-play-overlay"
      @click="handleTap"
    >
      <div class="tap-to-play-content">
        <v-icon class="play-icon" color="white" size="64">
          mdi-play-circle-outline
        </v-icon>
        <span class="tap-text">Tap to play</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import VideoService from '@/services/VideoService';

export default {
  name: 'VideoTapToPlayOverlay',

  computed: {
    ...mapGetters({
      pendingTapToPlay: 'video/pendingTapToPlay',
    }),

    showOverlay() {
      return this.pendingTapToPlay;
    },
  },

  methods: {
    handleTap() {
      // Forward the click to Plyr's native play button synchronously.
      // When called from a real user gesture handler, .click() dispatches
      // a trusted click event that iOS Safari treats as user-activated.
      const plyrPlayButton = document.querySelector('.plyr__control--overlaid');
      if (plyrPlayButton) {
        plyrPlayButton.click();
      } else {
        // Fallback: call play directly (may not establish sticky activation)
        VideoService.play();
      }

      // Mark playback as unlocked so overlay won't show again this session
      this.$store.dispatch('video/unlockPlayback');
    },
  },
};
</script>

<style scoped>
.tap-to-play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  z-index: 3;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.tap-to-play-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
}

.play-icon {
  opacity: 0.9;
}

.tap-text {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
}

.overlay-fade-leave-active {
  transition: opacity 0.3s ease;
}

.overlay-fade-leave-to {
  opacity: 0;
}
</style>
